function readMoreInit() {
	const toggler = document.querySelector("[data-read-more='toggler']");
	const target = document.querySelector("[data-read-more='container']");
	const activeClass = "read-more-is-toggled";

	if (target) {
		target.style.setProperty("--itemAllQty", target.childElementCount);
		target.style.setProperty("--itemMinQty", target.dataset.readMoreMinItems);
	}

	if (toggler) {
		toggler.addEventListener("click", function() {
			if (this.getAttribute("aria-expanded") == "false") {
				this.setAttribute("aria-expanded", "true");
				target.classList.add(activeClass);
			} else {
				this.setAttribute("aria-expanded", "false");
				target.classList.remove(activeClass);
			}
		});
	}
	return;
}
